import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { ENEM_GABARITO_REDIRECTS, ENEM_GABARITO_ROOT, ENEM_GABARITO_YEARS, enemGabaritoPaths } from '../utils/paths';

// Lazy load das páginas
const EditionLayout = lazy(() => import('../components/EditionLayout'));
const CurrentEditionRedirect = lazy(() => import('../components/CurrentEditionRedirect'));
const PathRedirect = lazy(() => import('../components/PathRedirect'));
const Home = lazy(() => import('../pages/Home'));
const CadastroInicial = lazy(() => import('../pages/CadastroInicial'));
const PreenchimentoRespostas = lazy(() => import('../pages/PreenchimentoRespostas'));
const NotasOficiais = lazy(() => import('../pages/NotasOficiais'));

// Calculadora TRI por edição: uma rota /enem-gabarito-<ano> por ano listado em
// utils/paths. A edição do ano é validada contra a API no EditionLayout.
const editionRoute = (year: number): RouteObject => ({
  path: enemGabaritoPaths(year).home,
  element: <EditionLayout year={year} />,
  children: [
    {
      index: true,
      element: <Home />,
    },
    {
      path: 'cadastro',
      element: <CadastroInicial />,
    },
    {
      path: 'preencher',
      element: <PreenchimentoRespostas />,
    },
    {
      path: 'notas-oficiais',
      element: <NotasOficiais />,
    },
    {
      // Rota antiga de 2025: a cor é escolhida no preenchimento
      path: 'selecionar-cor/:dia',
      element: <Navigate to="../preencher" replace />,
    },
    {
      path: '*',
      element: <Navigate to=".." replace />,
    },
  ],
});

export const enemGabaritoRoutes: RouteObject[] = [
  {
    path: ENEM_GABARITO_ROOT,
    element: <CurrentEditionRedirect />,
  },
  ...ENEM_GABARITO_YEARS.map(editionRoute),
  ...Object.entries(ENEM_GABARITO_REDIRECTS).map(([from, to]) => ({
    path: `${ENEM_GABARITO_ROOT}-${from}/*`,
    element: <PathRedirect to={enemGabaritoPaths(to).home} />,
  })),
];
